
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface CompanyFormFieldsProps {
  formData: {
    name_ar: string;
    mobile: string;
    address_ar: string;
  };
  onFormChange: (data: Partial<{
    name_ar: string;
    mobile: string;
    address_ar: string;
  }>) => void;
}

export const CompanyFormFields = ({ formData, onFormChange }: CompanyFormFieldsProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="name_ar">الاسم بالعربية *</Label>
        <Input
          id="name_ar"
          value={formData.name_ar}
          onChange={(e) => onFormChange({ name_ar: e.target.value })}
          required
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="mobile">الموبايل</Label>
        <Input
          id="mobile"
          value={formData.mobile}
          onChange={(e) => onFormChange({ mobile: e.target.value })}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="address_ar">العنوان بالعربية</Label>
        <Textarea
          id="address_ar"
          value={formData.address_ar}
          onChange={(e) => onFormChange({ address_ar: e.target.value })}
          rows={3}
        />
      </div>
    </>
  );
};
